import { useEffect } from 'react';
import InnerPageHero from '../components/InnerPageHero';
import FinancingOverview from '../components/FinancingOverview';
import FinancingHowItWorks from '../components/FinancingHowItWorks';
import Financing from '../components/Financing';
import FinancingBenefits from '../components/FinancingBenefits';
import FAQ from '../components/FAQ';
import { useContent } from '../context/ContentContext';

export default function FinancingPage() {
  const { content } = useContent();
  const d = content.financingHero;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main id="main-content" tabIndex={-1}>
      <InnerPageHero
        breadcrumbs={[
          { label: 'Home', href: '/' },
          { label: 'Financing' },
        ]}
        title={d.title}
        titleAccent={d.titleAccent}
        titleSuffix={d.titleSuffix}
        description={d.description}
      />
      <FinancingOverview />
      <FinancingHowItWorks />
      <Financing />
      <FinancingBenefits />
      <FAQ />
    </main>
  );
}
